import { Tooltip, TooltipProps } from '@mui/material';
import { token } from '@styled/tokens';
import React from 'react';

import './ErrorTooltip.scss';

import { AUTOMATION_IDS } from 'state_management/automationIds';

function ErrorTooltip(props: TooltipProps) {
  return (
    <Tooltip
      classes={{ tooltip: 'errorTooltip' }}
      data-testid={AUTOMATION_IDS.ERROR_TOOL_TIP.TOOLTIP}
      {...props}
      PopperProps={{ ...props.PopperProps, style: { ...props.PopperProps?.style, zIndex: token('zIndex.modal') } }}>
      {props.children}
    </Tooltip>
  );
}

export default ErrorTooltip;
